var app = angular.module("leonardo");

var DynamicFormCloneDialog = function($scope, DynamicFormRestService) {

  $scope.dynamic_form = $scope.ngDialogData.dynamic_form;
  var dynamic_formID = $scope.dynamic_form.id;
  delete($scope.dynamic_form.id);

  if ($scope.dynamic_form.sectors && ($scope.dynamic_form.sectors.length > 0)){
    var sectors = [];
    angular.forEach($scope.dynamic_form.sectors, function(sector){
      sectors.push(sector.id);
    });
    $scope.dynamic_form.sectors = sectors;
  }

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.invalid) {
      return;
    }
    DynamicFormRestService.get(dynamic_formID).then(function (data) {
      $scope.dynamic_form.fields = data.fields;
      $scope.confirm($scope.dynamic_form);
    });
  };

};

app.controller('DynamicFormCloneDialog', ['$scope', 'DynamicFormRestService', DynamicFormCloneDialog]);
